import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

// Material UI
import Typography from '@material-ui/core/Typography';

// Data
import { IDropFile } from './drop-file.interfaces';

// Components
import { DropFileWrapper } from './drop-file-wrapper.component';

export const DropFile: React.FC<IDropFile> = ({
  children,
  onReceivedFiles,
  onFileDialogOpen,
  onFileDialogCancel,
  disabled,
  noClick,
  useWrapper
 }) => {
  const onDrop = useCallback(acceptedFiles => {
    onReceivedFiles(acceptedFiles);
  }, [onReceivedFiles]);

  // Never pass `disabled` to useDropzone — it nulls the hidden input's onChange. See
  // "Upload buttons go busy at file-dialog open, not upload start" in CLAUDE.md.
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onFileDialogOpen,
    onFileDialogCancel,
    noClick: noClick || disabled,
    noDrag: disabled,
    noKeyboard: disabled,
  });

  const dropContent = useWrapper
    ? <DropFileWrapper><Typography>Drop the files here ...</Typography></DropFileWrapper>
    : <Typography>Drop the files here...</Typography>;

  // Only the drop area fills its box; inline the root hugs its children, so the invisible
  // click target never reaches past the control and opens the picker from stray clicks.
  const content = (
    <div {...getRootProps()} style={useWrapper ? { width: '100%' } : undefined}>
      <input {...getInputProps()} />
      {isDragActive ? dropContent : children}
    </div>
  );

  return useWrapper ? <DropFileWrapper>{content}</DropFileWrapper> : content;
}
